import { render, staticRenderFns } from "./LoginConfig.vue?vue&type=template&id=496f6b2e&scoped=true"
import script from "./LoginConfig.vue?vue&type=script&lang=js"
export * from "./LoginConfig.vue?vue&type=script&lang=js"
import style0 from "./LoginConfig.vue?vue&type=style&index=0&id=496f6b2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f6b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496f6b2e')) {
      api.createRecord('496f6b2e', component.options)
    } else {
      api.reload('496f6b2e', component.options)
    }
    module.hot.accept("./LoginConfig.vue?vue&type=template&id=496f6b2e&scoped=true", function () {
      api.rerender('496f6b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/data/LoginConfig.vue"
export default component.exports